import type { SaveSourceTextToSkipBody, SourceTextToSkip } from "@rebuild/shared";
import RestAPI from "../../utils/restAPI";

const ROUTE = "/rest/tools/sourceTextsToSkip";

function requireResult<T>(result: T | null | undefined, action: string): T {
  if (result == null) {
    throw new Error(`Failed to ${action} source text to skip`);
  }
  return result;
}

export async function fetchSourceTextsToSkip(): Promise<SourceTextToSkip[]> {
  return requireResult(await RestAPI.fetchRebuildAPI(ROUTE, "GET", {}, "data", true, false), "fetch");
}

export async function saveSourceTextToSkip(body: SaveSourceTextToSkipBody): Promise<SourceTextToSkip> {
  if (body.id) {
    return requireResult(await RestAPI.fetchRebuildAPI(`${ROUTE}/${body.id}`, "PATCH", body, "data", true, false), "save");
  }
  return requireResult(await RestAPI.fetchRebuildAPI(ROUTE, "POST", body, "data", true, false), "save");
}

export async function deleteSourceTextToSkip(id: string): Promise<void> {
  requireResult(await RestAPI.fetchRebuildAPI(`${ROUTE}/${id}`, "DELETE", {}, "success", true, false), "delete");
}
